<template lang="pug">
div
  .d-flex.align-center.gap-4.mb-2(v-if="label")
    span.weight-500 {{ currentLabel }}
    span.weight-400(v-if="description") ({{ description }})
    tooltip-wrap(
      v-if="tooltip"
      :value="!!tooltip"
      top
      :max-width="350"
      content-class="redesign redesignControlsBackground redesign-box-shadow rounded-8 opacity-100"
    )
      template(#reason)
        p.redesignPrimaryDarken--text {{ tooltip }}
      v-icon.ml-1(v-if="tooltip" size="18" color="redesignPrimaryDarken") $iinfo
  slot(name="default" :component="component")
    component(
      v-if="component"
      :is="component.is"
      v-bind="extendProps.attrs"
      v-on="extendProps.listeners"
    )
</template>

<script>
export default {
  name: 'AppLabelWrapper',

  props: {
    label: { type: String, default: null },
    required: { type: Boolean, default: false },
    description: { type: String, default: '' },
    tooltip: { type: String, default: null },
    /**
     * @type {Object} {
     *  is: Component,
     *  attrs: Object,
     *  listeners: Object,
     * }
     */
    component: { type: Object, default: null },
    inheritProps: { type: Boolean, default: false },
  },

  computed: {
    extendProps() {
      const { component, inheritProps } = this;
      const { attrs, listeners } = component || {};
      if (inheritProps) {
        // TODO: исправить
        /** Костыль, так как в новую ApiForm добавлен слушатель,
         * он вызывал бесконечный цикл обновлений.
         */
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        delete this.$listeners['hook:mounted'];
        return {
          attrs: {
            ...this.$attrs,
            ...attrs,
          },
          listeners: {
            ...this.$listeners,
            ...listeners,
          },
        };
      }
      return { attrs, listeners };
    },
    currentLabel() {
      const { required, label } = this;
      return required ? `${label}*` : label;
    },
  },
};
</script>
